<!--
 * @Author: chengjia 645680217@qq.com
 * @Date: 2023-02-09 17:54:30
 * @LastEditors: chengjia 645680217@qq.com
 * @LastEditTime: 2023-02-28 17:54:11
 * @FilePath: \xm-runing-main\src\systemPage\password\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <PageWrapper :title="t('component.password.修改当前用户密码')"
               :content="t('component.password.修改成功后会自动退出当前登录！')">
    <div
      class="py-8 bg-white flex flex-col justify-center items-center"
      style="margin-top: 0; padding: 0 20px 100px 20px"
    >
      <BasicForm @register="register"/>
      <div class="flex justify-center">
        <a-button @click="resetFields"> {{ t('component.password.重置') }}</a-button>
        <a-button class="!ml-4" type="primary" @click="handleSubmit">{{
            t('component.password.确认')
          }}
        </a-button>
      </div>
    </div>
  </PageWrapper>
</template>
<script lang="ts">
import {defineComponent} from 'vue';
import {PageWrapper} from '@/components/Page';
import {BasicForm, useForm} from '@/components/Form';
import {updatePwdApi} from '@/api/index';
import {dbUtils, GoingNewUtils} from 'xmgoing-utils';
import {formSchema} from './pwd.data';
import {notification} from 'ant-design-vue';
import {useUserStore} from '@/store/modules/user';
import {useI18n} from '@/hooks/web/useI18n';
import {md5Str} from 'xmgoing-utils';
import GoingUtils from "@/utils/goingUtils";
import {loadOutSystem} from "@/utils/xmCom/loadSystem";

export default defineComponent({
  name: 'ChangePassword',
  components: {BasicForm, PageWrapper},
  emits: ['setisModPwd'],
  props: {
    pwdConfig:{},
    isModPwd: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, {emit}) {
    const pwdConfigVal=unref(props).pwdConfig;
    //获取 新密码和老密码是否可以一样
    const {somePweFlag}=pwdConfigVal||{};
    (window as any).somePweFlag=GoingNewUtils.parseBoolean(somePweFlag);
    const {t}: any = useI18n()
    const userStore = useUserStore();
    //处理国际化
    formSchema.forEach((item) => {
      item.label = t(item.label);
      if (item.componentProps) {
        item.componentProps.placeholder = t(item.componentProps.placeholder);
      }
    })


    const [register, {validate, resetFields}] = useForm({
      size: 'large',
      baseColProps: {span: 24},
      labelWidth: 100,
      showActionButtonGroup: false,
      schemas: formSchema,
    });

    async function handleSubmit() {
      emit('setisModPwd', true);
      try {
        const values = await validate();
        const {
          passwordOld: orgPassword,
          passwordNew: password,
          confirmPassword: pwdConfirm,
        } = values;
        if(GoingNewUtils.parseBoolean(somePweFlag)&&(orgPassword===password)){
          GoingUtils.showErrorMessage("新密码不能与上次密码一样！");
          return;
        }
        await updatePwdApi({
          orgPassword: md5Str(orgPassword).toString(),
          password: md5Str(password).toString(),
          pwdConfirm: md5Str(pwdConfirm).toString(),
        }).then(() => {
          notification.success({
            message: t('layout.setting.operatingTitle'),
            description: t('component.password.修改密码成功'),
          });
          setTimeout(() => {
            loadOutSystem({});
          }, 600);
        });
      } catch (error) {
        emit('setisModPwd', false);
      }
    }


    return {somePweFlag,register, resetFields, handleSubmit, t};
  },
});
</script>
